export const columnsMembers = (teams) => [
  {
    name: 'Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Work Email',
    selector: (row) => row.attributes.email,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
    filter: teams && ({
      type: 'MULTI_SELECT',
      options: teams.map((team) => team.attributes.title),
    }),
  },
  {
    name: 'Program',
    selector: (row) => row.attributes.programs.map((program) => program.title).join(', '),
  },
  {
    name: 'Members not currently in a program',
    selector: (row) => row.attributes.programs_state.toString(),
    omit: true,
    filter: {
      type: 'SINGLE_SELECT',
      defaultValue: 'no_assigned',
      options: [
        { label: 'No programs assigned', value: 'no_assigned' },
        { label: 'Programs assigned', value: 'with_assigned' },
        { label: 'Custom Programs', value: 'custom_programs' },
      ],
    },
  },
];

export const columnsTeams = [
  {
    name: 'Team',
    selector: (row) => row.attributes.title,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Number of Members',
    selector: (row) => row.attributes.team_size,
  },
];
